// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page{\n  min-height: calc( 100vh - 240px );\n}\nbody{\n  font-family: 'Open Sans';\n}", "",{"version":3,"sources":["webpack://src/App.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".page{\n  min-height: calc( 100vh - 240px );\n}\nbody{\n  font-family: 'Open Sans';\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
